import { api, Response } from '../../function/axios'
import { downloadBlob } from '../../store/support/service'

// Shared by PopupCreateQrRegistration.tsx (download right after creating)
// and QrRegistrationPage.tsx's table row action — GET .../pdf returns the
// raw PDF bytes (see AuthController#downloadQrRegistrationPdf), so this
// pulls it as a blob and reuses the same download-a-blob helper already
// used for ticket attachments (store/support/service.ts).
export async function downloadQrRegistrationPdf(id: number): Promise<void> {
  const { data }: Response = await api({
    method: 'GET',
    url: `/auth/qr-registration/${id}/pdf`,
    responseType: 'blob',
  })

  downloadBlob(new Blob([data], { type: 'application/pdf' }), `qr-registration-${id}.pdf`)
}
